import { Message } from 'data/firestore/message/types';

const switchRole = (role: Message['role']) => (
    role === 'assistant'
        ? 'user'
        : 'assistant'
);

export default switchRole;
